@if (node) {
  <div class="filter-node-editor">
    {{node.operator}}
  </div>
}